import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.simulation');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const DATASET_PROJECT_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-simulation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.simulation/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSimulationComponent implements OnInit, OnDestroy {
    @ViewChild('momentChart') momentChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('forceChart') forceChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('speedChart') speedChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('tempChart') tempChart?: ElementRef<HTMLCanvasElement>;

    public step: number = 1;
    public isRunning: boolean = false;

    // 가동부 정보
    public partType: string = '도어';
    public hingeType: string = '단축';
    public weight: number = 12;
    public cogX: number = 0.15;
    public cogY: number = 0.0;
    public cogZ: number = -0.02;

    // 기구학 좌표
    public hingeX: number = 0.0;
    public hingeY: number = 0.0;
    public hingeZ: number = 0.0;
    public mountX: number = 0.05;
    public mountY: number = 0.12;
    public mountZ: number = -0.03;

    // 설계 목표
    public targetAngle: number = 80;
    public targetTime: number = 3.5;

    // 환경 조건
    public voltage: number = 12;
    public temperature: number = 25;

    // 시뮬레이션 결과
    public results: any = null;

    // 장착 최적화 결과
    public optimizeResult: any = null;
    public isOptimizing: boolean = false;

    // CAD 간극 보정 결과
    public cadGapResult: any = null;
    public cadLength: number = 250;
    public isCheckingGap: boolean = false;

    // 전기 특성 예측 결과
    public electricalResult: any = null;
    public isLoadingElectrical: boolean = false;

    public partTypes: string[] = ['도어', '트렁크', '시트', '에어로파츠'];
    public hingeTypes: string[] = ['단축', '다축', '4절링크'];
    private charts: Chart[] = [];

    // 가동부별 기본 템플릿
    public presets: any = {
        '도어': { weight: 35, targetAngle: 85, targetTime: 3, cogX: 0.3, cogY: 0, cogZ: -0.03, mountX: 0.05, mountY: 0.25, mountZ: -0.03, voltage: 12 },
        '트렁크': { weight: 18, targetAngle: 70, targetTime: 4, cogX: 0.4, cogY: 0, cogZ: -0.05, mountX: 0.05, mountY: 0.3, mountZ: -0.03, voltage: 12 },
        '시트': { weight: 25, targetAngle: 50, targetTime: 4, cogX: 0.2, cogY: 0, cogZ: -0.02, mountX: 0.05, mountY: 0.15, mountZ: -0.03, voltage: 12 },
        '에어로파츠': { weight: 5, targetAngle: 45, targetTime: 2, cogX: 0.15, cogY: 0, cogZ: -0.01, mountX: 0.05, mountY: 0.1, mountZ: -0.03, voltage: 12 },
    };

    // 시나리오 관리
    public scenarios: any[] = [];
    public scenarioName: string = '';

    // 배치 시뮬레이션
    public batchResults: any[] = [];
    public isBatchRunning: boolean = false;
    public batchGrid: number = 3;
    public batchStep: number = 0.02;
    public batchSweepWeight: string = '';
    public batchSweepTemp: string = '';
    public batchSweepVoltage: string = '';

    // 환경 변수 스윕
    public envSweepResults: any[] = [];
    public envTempCurve: any[] = [];
    public isEnvSweeping: boolean = false;
    public envSweepTemps: string = '-30,-10,0,25,50,80';
    public envSweepVolts: string = '12';

    // AI 데이터셋 생성
    public aiDataset: any = null;
    public isGeneratingDataset: boolean = false;
    public aiSweepWeight: string = '';
    public aiSweepTemp: string = '';
    public aiSweepVoltage: string = '';
    public aiGrid: number = 3;
    public aiStep: number = 0.02;
    public projectId: string = '';
    public datasetProjects: any[] = [];
    public datasetCatalog: any[] = [];
    public selectedDataset: any = null;
    public datasetName: string = 'AI 학습 데이터셋';
    public datasetVersion: string = '';
    public datasetTags: string = 'synthetic,simulation';
    public datasetCatalogTotal: number = 0;
    public isLoadingDatasetCatalog: boolean = false;
    public datasetLimitRows: number = 1500;

    // 배치 결과 필터
    public batchFilterMinEff: number = 0;
    public batchSortKey: string = 'efficiency';
    public batchSortDesc: boolean = true;

    // 장착 최적화 탐색 범위
    public searchRange: number = 0.03;
    public boundMinX: number = -0.3;
    public boundMinY: number = -0.3;
    public boundMinZ: number = -0.3;
    public boundMaxX: number = 0.3;
    public boundMaxY: number = 0.3;
    public boundMaxZ: number = 0.3;
    public gridSteps: number = 3;

    // 3D 바운더리 간섭 체크 (FN-0003)
    public collisionResult: any = null;
    public isCheckingCollision: boolean = false;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        this.loadScenariosFromStorage();
        this.projectId = this.routeDatasetProjectId();
        await this.loadDatasetProjects();
        await this.loadDatasetCatalog();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyCharts();
    }

    private routeDatasetProjectId(): string {
        const params = new URLSearchParams(location.search);
        const queryId = params.get('project_id') || '';
        if (queryId) return queryId;
        try {
            return localStorage.getItem(DATASET_PROJECT_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    private rememberDatasetProject(id: string) {
        if (!id) return;
        try {
            localStorage.setItem(DATASET_PROJECT_KEY, id);
            const url = new URL(location.href);
            url.searchParams.set('project_id', id);
            history.replaceState(null, '', url.toString());
        } catch (e) {}
    }

    private apiMessage(data: any, fallback: string): string {
        return data?.message || data?.data?.message || (typeof data === 'string' ? data : '') || fallback;
    }

    private async loadDatasetProjects() {
        const { code, data } = await wiz.call('dataset_projects');
        if (code !== 200) {
            this.datasetProjects = [];
            return;
        }
        this.datasetProjects = data || [];
        const exists = this.datasetProjects.some((project: any) => project.id === this.projectId);
        if (!exists) {
            this.projectId = this.datasetProjects[0]?.id || '';
        }
        if (this.projectId) this.rememberDatasetProject(this.projectId);
    }

    public async selectDatasetProject(projectId: string) {
        this.projectId = projectId || '';
        this.selectedDataset = null;
        this.aiDataset = null;
        if (this.projectId) this.rememberDatasetProject(this.projectId);
        await this.loadDatasetCatalog();
        await this.service.render();
    }

    public selectedDatasetProjectLabel(): string {
        const project = this.datasetProjects.find((item: any) => item.id === this.projectId);
        if (!project) return '프로젝트 미선택';
        const detail = [project.vehicle, project.partType].filter((value: string) => !!value).join(' · ');
        return detail ? `${project.title} (${detail})` : project.title;
    }

    private sweepValueCount(raw: string): number {
        const value = String(raw || '').trim();
        if (!value) return 1;
        return value.split(',').filter((item: string) => !!item.trim()).length;
    }

    public estimatedDatasetRows(): number {
        const grid = Number(this.aiGrid);
        if (!Number.isInteger(grid) || grid < 0) return 0;
        return Math.pow(grid * 2 + 1, 2)
            * this.sweepValueCount(this.aiSweepWeight)
            * this.sweepValueCount(this.aiSweepTemp)
            * this.sweepValueCount(this.aiSweepVoltage);
    }

    public datasetSizeLabel(bytes: any): string {
        const value = Number(bytes || 0);
        if (value < 1024) return `${value} B`;
        if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
        return `${(value / (1024 * 1024)).toFixed(1)} MB`;
    }

    public async loadDatasetCatalog() {
        this.datasetCatalog = [];
        this.datasetCatalogTotal = 0;
        if (!this.projectId) return;
        this.isLoadingDatasetCatalog = true;
        const { code, data } = await wiz.call('dataset_catalog_list', {
            project_id: this.projectId,
            page: 1,
            dump: 50
        });
        this.isLoadingDatasetCatalog = false;
        if (code === 200) {
            this.datasetCatalog = data?.items || [];
            this.datasetCatalogTotal = Number(data?.total || 0);
        } else {
            await this.service.modal.error(this.apiMessage(data, '데이터셋 카탈로그를 불러오지 못했습니다.'));
        }
    }

    public async openDatasetDetail(item: any) {
        const { code, data } = await wiz.call('dataset_catalog_detail', { id: item?.id });
        if (code === 200) {
            this.selectedDataset = data;
        } else {
            await this.service.modal.error(this.apiMessage(data, '데이터셋 상세 정보를 불러오지 못했습니다.'));
        }
        await this.service.render();
    }

    public async regenerateDataset(item: any) {
        if (!item?.id || this.isGeneratingDataset) return;
        this.isGeneratingDataset = true;
        const { code, data } = await wiz.call('dataset_catalog_regenerate', { id: item.id });
        this.isGeneratingDataset = false;
        if (code === 200) {
            this.aiDataset = data;
            this.selectedDataset = data?.catalog || null;
            await this.loadDatasetCatalog();
        } else {
            await this.service.modal.error(this.apiMessage(data, '데이터셋을 재생성하지 못했습니다.'));
        }
        await this.service.render();
    }

    public async deleteDataset(item: any) {
        if (!item?.id) return;
        const confirmed = await this.service.modal.show({
            title: '데이터셋 삭제',
            message: `${item.name || '데이터셋'} ${item.version || ''}을(를) 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('dataset_catalog_delete', { id: item.id });
        if (code === 200) {
            if (this.selectedDataset?.id === item.id) this.selectedDataset = null;
            await this.loadDatasetCatalog();
        } else {
            await this.service.modal.error(this.apiMessage(data, '데이터셋을 삭제하지 못했습니다.'));
        }
        await this.service.render();
    }

    public applyPreset(partType: string) {
        const preset = this.presets[partType];
        if (!preset) return;
        this.partType = partType;
        Object.assign(this, preset);
    }

    public saveScenario() {
        if (!this.scenarioName.trim()) return;
        const scenario = {
            name: this.scenarioName,
            date: new Date().toISOString().slice(0, 10),
            params: this.getSimParams()
        };
        this.scenarios.push(scenario);
        this.saveScenarioStorage();
        this.scenarioName = '';
    }

    public loadScenario(s: any) {
        const p = s.params;
        this.partType = p.partType || '도어';
        this.hingeType = p.hingeType || '단축';
        this.weight = p.weight; this.cogX = p.cogX; this.cogY = p.cogY; this.cogZ = p.cogZ;
        this.hingeX = p.hingeX; this.hingeY = p.hingeY; this.hingeZ = p.hingeZ;
        this.mountX = p.mountX; this.mountY = p.mountY; this.mountZ = p.mountZ;
        this.targetAngle = p.targetAngle; this.targetTime = p.targetTime;
        this.voltage = p.voltage; this.temperature = p.temperature;
    }

    public deleteScenario(i: number) {
        this.scenarios.splice(i, 1);
        this.saveScenarioStorage();
    }

    private saveScenarioStorage() {
        try { localStorage.setItem('sim_scenarios', JSON.stringify(this.scenarios)); } catch(e) {}
    }
    private loadScenariosFromStorage() {
        try { this.scenarios = JSON.parse(localStorage.getItem('sim_scenarios') || '[]'); } catch(e) { this.scenarios = []; }
    }

    public async runSimulation() {
        this.isRunning = true;
        await this.service.render();

        const params = {
            partType: this.partType,
            hingeType: this.hingeType,
            weight: this.weight,
            cogX: this.cogX,
            cogY: this.cogY,
            cogZ: this.cogZ,
            hingeX: this.hingeX,
            hingeY: this.hingeY,
            hingeZ: this.hingeZ,
            mountX: this.mountX,
            mountY: this.mountY,
            mountZ: this.mountZ,
            targetAngle: this.targetAngle,
            targetTime: this.targetTime,
            voltage: this.voltage,
            temperature: this.temperature
        };

        const { code, data } = await wiz.call("run_simulation", params);

        this.isRunning = false;

        if (code === 200) {
            this.results = data;
            this.step = 2;
        }

        await this.service.render();
        this.renderChartsSoon();
    }

    public async resetSimulation() {
        this.destroyCharts();
        this.step = 1;
        this.results = null;
        this.optimizeResult = null;
        this.cadGapResult = null;
        this.electricalResult = null;
        await this.service.render();
    }

    public isGeneratingReport: boolean = false;

    public async generateReport() {
        if (!this.results) {
            return;
        }

        this.isGeneratingReport = true;
        await this.service.render();

        const payload: any = {
            partType: this.partType,
            hingeType: this.hingeType,
            weight: this.weight,
            cogX: this.cogX, cogY: this.cogY, cogZ: this.cogZ,
            hingeX: this.hingeX, hingeY: this.hingeY, hingeZ: this.hingeZ,
            mountX: this.mountX, mountY: this.mountY, mountZ: this.mountZ,
            targetAngle: this.targetAngle,
            targetTime: this.targetTime,
            voltage: this.voltage,
            temperature: this.temperature
        };

        const res: any = await wiz.call("generate_report", payload);

        this.isGeneratingReport = false;
        await this.service.render();

        if (res && res.code === 200) {
            this.service.href('/reports');
        }
    }

    private getSimParams(): any {
        return {
            partType: this.partType, hingeType: this.hingeType, weight: this.weight,
            cogX: this.cogX, cogY: this.cogY, cogZ: this.cogZ,
            hingeX: this.hingeX, hingeY: this.hingeY, hingeZ: this.hingeZ,
            mountX: this.mountX, mountY: this.mountY, mountZ: this.mountZ,
            targetAngle: this.targetAngle, targetTime: this.targetTime,
            voltage: this.voltage, temperature: this.temperature
        };
    }

    public async optimizeMount() {
        this.isOptimizing = true;
        this.optimizeResult = null;
        await this.service.render();

        const params = {
            ...this.getSimParams(),
            searchRange: this.searchRange,
            boundMinX: this.boundMinX, boundMinY: this.boundMinY, boundMinZ: this.boundMinZ,
            boundMaxX: this.boundMaxX, boundMaxY: this.boundMaxY, boundMaxZ: this.boundMaxZ,
            gridSteps: this.gridSteps
        };
        const { code, data } = await wiz.call("optimize_mount", params);
        this.isOptimizing = false;
        if (code === 200) {
            this.optimizeResult = data;
        }
        await this.service.render();
    }

    public async applyOptimal() {
        if (!this.optimizeResult?.optimal) return;
        this.mountX = this.optimizeResult.optimal.x;
        this.mountY = this.optimizeResult.optimal.y;
        this.mountZ = this.optimizeResult.optimal.z;
        this.optimizeResult = null;
        await this.runSimulation();
    }

    public async checkCadGap() {
        this.isCheckingGap = true;
        this.cadGapResult = null;
        await this.service.render();

        const { code, data } = await wiz.call("cad_gap_correction", { cadLength: this.cadLength });
        this.isCheckingGap = false;
        if (code === 200) {
            this.cadGapResult = data;
        }
        await this.service.render();
    }

    public async predictElectrical() {
        this.isLoadingElectrical = true;
        this.electricalResult = null;
        await this.service.render();

        const { code, data } = await wiz.call("predict_electrical", this.getSimParams());
        this.isLoadingElectrical = false;
        if (code === 200) {
            this.electricalResult = data;
        }
        await this.service.render();
    }

    public async runBatch() {
        this.isBatchRunning = true;
        this.batchResults = [];
        await this.service.render();

        const params: any = {
            ...this.getSimParams(),
            grid: this.batchGrid,
            step: this.batchStep
        };
        if (this.batchSweepWeight.trim()) params.sweepWeight = this.batchSweepWeight;
        if (this.batchSweepTemp.trim()) params.sweepTemp = this.batchSweepTemp;
        if (this.batchSweepVoltage.trim()) params.sweepVoltage = this.batchSweepVoltage;

        const { code, data } = await wiz.call("batch_generate", params);
        this.isBatchRunning = false;
        if (code === 200) {
            this.batchResults = data.data || [];
        } else {
            await this.service.modal.error(this.apiMessage(data, '배치 생성 입력값을 확인해주세요.'));
        }
        await this.service.render();
    }

    public getFilteredBatchResults(): any[] {
        let rows = this.batchResults;
        if (this.batchFilterMinEff > 0) {
            rows = rows.filter((r: any) => r.efficiency >= this.batchFilterMinEff);
        }
        const key = this.batchSortKey;
        const dir = this.batchSortDesc ? -1 : 1;
        rows = [...rows].sort((a: any, b: any) => (a[key] - b[key]) * dir);
        return rows;
    }

    public sortBatch(key: string) {
        if (this.batchSortKey === key) {
            this.batchSortDesc = !this.batchSortDesc;
        } else {
            this.batchSortKey = key;
            this.batchSortDesc = true;
        }
    }

    public async runEnvSweep() {
        this.isEnvSweeping = true;
        this.envSweepResults = [];
        this.envTempCurve = [];
        await this.service.render();

        const params: any = {
            ...this.getSimParams(),
            temperatures: this.envSweepTemps,
            voltages: this.envSweepVolts,
        };

        const { code, data } = await wiz.call("env_sweep", params);
        this.isEnvSweeping = false;
        if (code === 200) {
            this.envSweepResults = data.sweepResults || [];
            this.envTempCurve = data.tempCurve || [];
        } else {
            await this.service.modal.error(this.apiMessage(data, '환경 스윕 입력값을 확인해주세요.'));
        }
        await this.service.render();
    }

    public async generateAiDataset() {
        if (!this.projectId) {
            await this.service.modal.error('데이터셋을 저장할 프로젝트를 선택해주세요.');
            return;
        }
        this.isGeneratingDataset = true;
        this.aiDataset = null;
        await this.service.render();

        const params: any = {
            ...this.getSimParams(),
            project_id: this.projectId,
            store: true,
            datasetName: this.datasetName,
            datasetVersion: this.datasetVersion,
            datasetTags: this.datasetTags,
            grid: this.aiGrid,
            step: this.aiStep,
        };
        if (this.aiSweepWeight.trim()) params.sweepWeight = this.aiSweepWeight;
        if (this.aiSweepTemp.trim()) params.sweepTemp = this.aiSweepTemp;
        if (this.aiSweepVoltage.trim()) params.sweepVoltage = this.aiSweepVoltage;

        const { code, data } = await wiz.call("generate_ai_dataset", params);
        this.isGeneratingDataset = false;
        if (code === 200) {
            this.aiDataset = data;
            this.selectedDataset = data?.catalog || null;
            this.datasetVersion = '';
            await this.loadDatasetCatalog();
        } else {
            await this.service.modal.error(this.apiMessage(data, 'AI 데이터셋 생성 입력값을 확인해주세요.'));
        }
        await this.service.render();
    }

    public exportAiDataset(format: string) {
        if (!this.aiDataset?.dataset?.length) return;
        if (format === 'json') {
            const blob = new Blob([JSON.stringify(this.aiDataset, null, 2)], { type: 'application/json' });
            this.downloadBlob(blob, 'ai_dataset.json');
        } else {
            const rows = this.aiDataset.dataset;
            const keys = Object.keys(rows[0]);
            const header = keys.join(',');
            const csv = [header, ...rows.map((r: any) => keys.map(k => r[k]).join(','))].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            this.downloadBlob(blob, 'ai_dataset.csv');
        }
    }

    private downloadBlob(blob: Blob, filename: string) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    }

    public exportBatch(format: string) {
        if (!this.batchResults?.length) return;
        const blob = format === 'json'
            ? new Blob([JSON.stringify(this.batchResults, null, 2)], { type: 'application/json' })
            : new Blob([this.batchToCsv()], { type: 'text/csv' });
        this.downloadBlob(blob, `batch_simulation.${format}`);
    }

    private batchToCsv(): string {
        if (!this.batchResults?.length) return '';
        const keys = Object.keys(this.batchResults[0]);
        const header = keys.join(',');
        const rows = this.batchResults.map((r: any) => keys.map(k => r[k]).join(','));
        return [header, ...rows].join('\n');
    }

    private renderChartsSoon() {
        setTimeout(() => this.renderCharts(), 50);
    }

    // 3D 바운더리 간섭 체크 (FN-0003)
    public async checkCollision() {
        this.isCheckingCollision = true;
        await this.service.render();
        const params = this.getSimParams();
        params.boundMinX = this.boundMinX;
        params.boundMinY = this.boundMinY;
        params.boundMinZ = this.boundMinZ;
        params.boundMaxX = this.boundMaxX;
        params.boundMaxY = this.boundMaxY;
        params.boundMaxZ = this.boundMaxZ;
        let res = await wiz.call("collision_check", params);
        this.isCheckingCollision = false;
        if (res.code === 200) {
            this.collisionResult = res.data;
        }
        await this.service.render();
    }

    private destroyCharts() {
        for (const chart of this.charts) {
            chart.destroy();
        }
        this.charts = [];
    }

    private renderCharts() {
        if (!this.results) return;
        this.destroyCharts();

        this.createLineChart(this.momentChart, '모멘트 (Nm)', this.results.momentData || [], 'angle', 'moment', '#67e8f9', 'rgba(103, 232, 249, 0.18)');
        this.createLineChart(this.forceChart, '힘 (N)', this.results.forceData || [], 'stroke', 'force', '#34d399', 'rgba(52, 211, 153, 0.18)');
        this.createLineChart(this.speedChart, '속도 (°/s)', this.results.speedData || [], 'time', 'speed', '#fbbf24', 'rgba(251, 191, 36, 0.18)');
        this.createLineChart(this.tempChart, '출력 비율 (%)', this.results.tempData || [], 'temp', 'output_ratio', '#fb923c', 'rgba(251, 146, 60, 0.18)');
    }

    private createLineChart(
        target: ElementRef<HTMLCanvasElement> | undefined,
        label: string,
        rows: any[],
        xKey: string,
        yKey: string,
        color: string,
        fillColor: string
    ) {
        if (!target?.nativeElement || !rows?.length) return;

        const chart = new Chart(target.nativeElement, {
            type: 'line',
            data: {
                labels: rows.map((row: any) => row[xKey]),
                datasets: [{
                    label,
                    data: rows.map((row: any) => row[yKey]),
                    borderColor: color,
                    backgroundColor: fillColor,
                    fill: true,
                    tension: 0.32,
                    pointRadius: 0,
                    pointHoverRadius: 3,
                    borderWidth: 2,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                },
                scales: {
                    x: {
                        ticks: { color: '#94a3b8', font: { size: 10 } },
                        grid: { color: 'rgba(148, 163, 184, 0.12)' }
                    },
                    y: {
                        ticks: { color: '#94a3b8', font: { size: 10 } },
                        grid: { color: 'rgba(148, 163, 184, 0.12)' }
                    }
                }
            }
        });

        this.charts.push(chart);
    }
}

export default PageSimulationComponent;